import { c as _c } from "react/compiler-runtime";
import { LoadingSpinner } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { HeaderTitle, NavigationHeader } from '@/idv/components';
import type { CameraPermissionState } from '../hooks/use-camera-permission';
type DesktopCameraPermissionProps = {
  permissionState: Exclude<CameraPermissionState, 'allowed'>;
};
const DesktopCameraPermission = t0 => {
  const $ = _c(12);
  const {
    permissionState
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.id-doc.pages.desktop-selfie.desktop-camera-permission"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <NavigationHeader leftButton={{
      variant: "close",
      confirmClose: true
    }} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t(_temp);
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div>{t2}<HeaderTitle title={t3} /></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== permissionState || $[7] !== t) {
    t5 = <div className="flex flex-col justify-center items-center bg-secondary rounded min-h-[280px]">{permissionState === "undetected" ? <LoadingSpinner size="xlarge" /> : <div className="pl-10 pr-10"><div className="text-label-2 text-center">{t($_0 => $_0.title[permissionState])}</div><div className="text-body-2 text-tertiary text-center">{t($_1 => $_1.subtitle[permissionState])}</div></div>}</div>;
    $[6] = permissionState;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex flex-col gap-6">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default DesktopCameraPermission;
function _temp($) {
  return $["take-selfie"];
}